import styled from 'styled-components';

import { basicSmallTextStyle, Link } from '@dreryk/react-components';

export const StyledCreateExtendedDosageLink = styled(Link)`
   ${basicSmallTextStyle};
`;

StyledCreateExtendedDosageLink.displayName = 'StyledCreateExtendedDosageLink';
